module.exports = __webpack_public_path__ + "img/0-134.f8058aff.jpg";